<mat-dialog-content>
    <div class="display-options-dialog-container">
        <div>
            <h2 class="g-card-title" style="width: 90%">{{ data.cardName ?? 'Title' }}</h2>
        </div>
        <display-options
                (displayOptionsOutput)="applyDisplayOptions($event)"
                [optionalSummaryList]="data.optionalSummaryList"
                [showEditButton]="true"
                [extraParameters]="null"
                [displayOptionsToReset]="null"
        >
        </display-options>

        <table>
            <tr>
                <td></td>
            </tr>
        </table>
        
    </div>



</mat-dialog-content>

<mat-dialog-actions align="end">
<!--    <button mat-button mat-dialog-close mat-stroked-button>Cancel</button>-->
<!--    <button mat-button cdkFocusInitial (click)="create()" mat-stroked-button>-->
<!--        Create Schedule-->
<!--    </button>-->
</mat-dialog-actions>

